import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class MoreIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="4" viewBox="0 0 16 4" width="16" xmlns="http://www.w3.org/2000/svg"><circle cx="14.4" cy="1.6" r="1.6"/><circle cx="8" cy="1.6" r="1.6"/><circle cx="1.6" cy="1.6" r="1.6"/></svg>
        )
    }
}

export default withCssClassName(MoreIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/more-icon.js